// このファイルを消してからmake driversすると生成し直しますが、ファイルがあれば上書きはされません。

export const initProcess = async () => {
  // 何か処理があれば書いてください
};
